/* eslint-disable max-len */
// /* global angular */

export default function EditSectionDialogController(
  $q,
  $rootScope,
  $scope,
  alerts,
  loaderService,
  pmSharedModelService,
  pmDataService,
  richTextEditorService,
  ssDialogService,
  materialChangeDialog
) {
  const vm = this;
  vm.bodyRteOptions = {
    height: 200,
    tokenAttrNames: ['pm-variable', 'pm-endnote'], // Required by richTextEditor to allow these html attributes
  };
  vm.tokens = {
    variables: [],
    endnotes: [],
    getToken(type, tag) {
      let key;
      switch (type) {
        case 'pm-variable':
          key = 'variables';
          break;
        case 'pm-endnote':
          key = 'endnotes';
          break;
        default:
          key = 'variables';
      }
      const collection = this[key];
      return collection.find(item => item.tag === tag);
    },
    hasData: false,
  };
  vm.additionalDetailsRteOptions = {
    height: 200,
  };
  vm.handleSaveProgress = _handleSaveProgress;
  vm.handleSaveAndClose = _handleSaveAndClose;
  vm.handleClose = _handleClose;
  vm.section.details = vm.section.details || '';
  vm.newSection = { ...vm.section };
  _activate();

  /** **************************************************
   * Event Handlers
   */

  function _handleSaveProgress() {
    _getRteContentForSave();
    const isNew = vm.newSection.policyDocumentSectionId < 0;
    if (isNew || !_isTitleOrBodyOrAdditionalDetailsChanged(vm.section, vm.newSection)) {
      _save(isNew);
    } else {
      _checkIsMaterialChange(
        (explanation) => {
          _save(isNew, explanation);
        }
      );
    }
  }

  function _handleSaveAndClose() {
    _getRteContentForSave();
    const isNew = vm.newSection.policyDocumentSectionId < 0;
    if (isNew || !_isTitleOrBodyOrAdditionalDetailsChanged(vm.section, vm.newSection)) {
      _save(isNew)
        .then(() => {
          _closeDialog();
        })
        .catch(e => console.warn(e));
    } else {
      _checkIsMaterialChange(
        (explanation) => {
          _save(isNew, explanation)
            .then(() => {
              _closeDialog();
            })
            .catch(e => console.warn(e));
        }
      );
    }
  }

  function _handleClose() {
    _closeDialog();
  }

  /** **************************************************
   * Private Functions
   */

  function _activate() {
    // Add listeners
    $scope.$on('pmEndnoteAdded', _loadEndnotes);
    $scope.$on('pmEndnoteUpdated', _loadEndnotes);
    $scope.$on('pmEndnoteDeleted', _loadEndnotes);
    $scope.$on('pmVariablesUpdated', _loadVariables);

    // Load viewmodels
    loaderService.showViewLoader = true;
    return $q.all([
      _loadEndnotes(),
      _loadVariables(),
      _renderBody(),
    ]).then(() => {
      loaderService.showViewLoader = false;
      vm.tokens.hasData = true;
    });
  }

  function _loadEndnotes() {
    return pmSharedModelService.getEndnotes(vm.policyDocumentId)
      .then((endnotes) => {
        vm.tokens.endnotes = endnotes;
      });
  }

  function _loadVariables() {
    return pmSharedModelService.getVariables(vm.policyDocumentId)
      .then((variables) => {
        vm.tokens.variables = variables;
      });
  }

  function _renderBody() {
    return pmDataService.getRenderedTopSection(vm.section.policyDocumentSectionId, false, false)
      .then((response) => {
        vm.newSection.staticBody = response.data.render;
      });
  }

  function _getRteContentForSave() {
    // Scope must be manually updated from the RTE editor
    if (vm.permissions.canEditDocument === true) {
      vm.newSection.body = richTextEditorService.getContent(`rteBody${vm.newSection.policyDocumentSectionId}`);
    }
    vm.newSection.details = richTextEditorService.getContent(`rteDetails${vm.newSection.policyDocumentSectionId}`);
  }

  function _checkIsMaterialChange(callback) {
    ssDialogService.dialogs.pm.materialChangeDialog = ssDialogService.alert(
      materialChangeDialog.getOptions({
        callback
      })
    );
    ssDialogService.show(ssDialogService.dialogs.pm.materialChangeDialog);
  }

  function _save(isNew, explanation) {
    if ($scope.pmEditSectionForm.$invalid) {
      return Promise.reject(new Error('Invalid form'));
    }

    if (!isNew && angular.equals(vm.section, vm.newSection)) {
      // No need to save
      return Promise.resolve();
    }

    loaderService.showViewLoader = true;

    if (explanation === undefined) {
      explanation = {
        explanation: null,
        isMaterialChange: null
      };
    }

    return pmSharedModelService.saveSection(vm.newSection, explanation)
      .then((savedSection) => {
        savedSection.policyDocumentSectionChildren = vm.section.policyDocumentSectionChildren;
        angular.extend(vm.newSection, savedSection.data);
        angular.extend(vm.section, vm.newSection);
        if (isNew) {
          $rootScope.$broadcast('pmSectionAdded', vm.section);
        }
        $rootScope.$broadcast('setDocumentRegenerateFlag');
        $rootScope.$broadcast('refreshPMDocuments');
        alerts.success('The section has been saved successfully.');
      })
      .catch(() => {
        alerts.error('An error occurred while saving the section.');
      })
      .finally(() => {
        loaderService.showViewLoader = false;
      });
  }

  function _isTitleOrBodyOrAdditionalDetailsChanged(section, newSection) {
    return (section.title !== newSection.title) || (section.body !== newSection.body)
      || (section.details !== newSection.details);
  }

  function _closeDialog() {
    richTextEditorService.destroy(vm.newSection.policyDocumentSectionId);
    const dialogId = `editSectionDialog${vm.newSection.policyDocumentSectionId}`;
    return ssDialogService.hide(ssDialogService.dialogs.pm[dialogId]);
  }
}

EditSectionDialogController.$inject = [
  '$q',
  '$rootScope',
  '$scope',
  'alerts',
  'loaderService',
  'pmSharedModelService',
  'pmDataService',
  'richTextEditorService',
  'ssDialogService',
  'materialChangeDialog',
];
